import axios from 'axios';

// v3 errors carry a machine-readable code in `type` (older payloads use `error`) and human text
// in `message`; validation failures return `message` as a list of field messages instead.
interface ApiErrorBody {
  type?: unknown;
  error?: unknown;
  message?: unknown;
}

function getErrorBody(error: unknown): ApiErrorBody | undefined {
  if (!axios.isAxiosError(error) || error.response === undefined) return undefined;
  if (error.response.status >= 500) return undefined;
  const { data } = error.response;
  return typeof data === 'object' && data !== null ? (data as ApiErrorBody) : undefined;
}

export function getApiErrorCode(error: unknown): string | undefined {
  const body = getErrorBody(error);
  const code = typeof body?.type === 'string' ? body.type : body?.error;
  return typeof code === 'string' ? code : undefined;
}

export function getApiErrorMessage(error: unknown): string | undefined {
  const message = getErrorBody(error)?.message;
  if (typeof message === 'string') return message;
  if (Array.isArray(message)) {
    const first: unknown = message[0];
    if (typeof first === 'object' && first !== null && 'message' in first) {
      const text = (first as { message: unknown }).message;
      if (typeof text === 'string') return text;
    }
  }
  return undefined;
}
